import React, { useMemo } from 'react';
import { useState } from 'react';
// @ts-ignore
import styles from './HealthPlanAddOption.module.scss';
import Text from '../../Base/Text/Text';
import Modal from '../../Modal/Modal';
import PlusButton from './PlusButton';
import source from './data.json';
import { useAppContext } from '../../../Services/AppContext';
import apiClient from '../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import OverlayLoading from '../../OverlayLoading';

interface Props {
	month: number;
	reloadData?: any;
}

const HealthPlanAddOption: React.FC<Props> = ({ reloadData, month }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [modalOpened, setModalOpened] = useState(false);
	const { translation, isLatam } = useAppContext();
	const { healthPlanUser } = useHealthPlanContext();
	const { isCase } = useTreatmentContext();

	// @ts-ignore
	const handleItemSelected = async (type: string) => {
		setIsLoading(false);
		const event = await apiClient.post(
			'/health-plan/' +
				healthPlanUser.healthPlanId +
				'/user/' +
				healthPlanUser.id +
				'/item/',
			{
				type: type,
				parentHealthPlanUserItemKey: 'timeline',
				extra: {
					custom: true,
					month: month,
					status: 'canFillNow',
					data: [],
				},
			},
		);
		if (!event?.data?.error) {
			setModalOpened(false);
			reloadData?.();
		}
		setIsLoading(false);
	};

	const data = useMemo(() => {
		if (isLatam) {
			return source;
		}
		return source.filter(item => item.type != 'vaccination');
	}, []);

	return (
		<>
			<div className={styles.wrapper} onClick={() => setModalOpened(true)}>
				<img src={'/dist/icons/react/circle-plus-solid-black.svg'} />
				<Text
					tx={'component.healthPlan.action.addCustomOption'}
					className={styles.title}
				/>
			</div>
			<Modal
				opened={modalOpened}
				onClose={() => setModalOpened(false)}
				wrapChat={isCase}>
				<Modal.Header title={translation['base.shared.pick']} />
				<Modal.Content>
					{data.map((item, index) => (
						<PlusButton item={item} key={index} onClick={handleItemSelected} />
					))}
				</Modal.Content>
			</Modal>
			{isLoading && <OverlayLoading />}
		</>
	);
};

export default HealthPlanAddOption;
